import React from 'react';
import { useNavigate } from 'react-router-dom';
// import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { NotFoundPageIcon } from '../../shared/component/svgIcon';
import Button from '../../shared/component/Button';
// import { resetAllSlices } from '../../redux/slices/ReduxStateResetSlice';

function NotFoundPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  // const dispatch = useDispatch();
  const handleNavigateLogin = () => {
    navigate('/login');
    // dispatch(resetAllSlices());
  };
  return (
    <div className="not-found">
      <div className="not-found-image">
        <NotFoundPageIcon />
      </div>
      <div className="not-found-text">
        <h1>{t('pageNotFound')}</h1>
        <h3>{t('pageNotFoundMassage')}</h3>
        <div className="not-found-button">
          <Button
            label={t('backToLogin')}
            click={handleNavigateLogin}
            classes="success-button"
          />
        </div>
      </div>
    </div>
  );
}

export default NotFoundPage;
